import store from "../store";

export const SnackbarMixin = {
  name: "snackbarMixin",
  methods: {
    showSnackbar(menssage, type = "success") {
      store.commit("showSnackbar", { menssage, type });
    },
  },
};